import { Portal } from "@mui/base";
import { forwardRef, useState, useImperativeHandle, useRef } from "react";
import lsKeys from "../../../default_values/defaultKeys";

export const Tooltip = forwardRef((_, ref) => {
  const [content, setContent] = useState("");
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const tooltipRef = useRef(null);

  useImperativeHandle(ref, () => ({
    setContent,
    setPosition,
  }));

  const lang = localStorage.getItem(lsKeys.LANGUAGE);

  const langWidth = lang === "de" ? 260 : 200;

  return (
    <>
      <Portal>
        <div
          className="reporting-tooltip"
          ref={tooltipRef}
          style={{
            visibility: content ? "visible" : "hidden",
            left: position.x - langWidth / 2 + 30,
            width: langWidth,
            top: position.y - 55,
          }}
        >
          {content}
        </div>
      </Portal>
    </>
  );
});

Tooltip.displayName = "Tooltip";
